import React, { useMemo } from "react";
import Navbar from "../../Navbar/Navbar";
import Bredcom from "../../Bredcom/Bredcom";
import Footer from "../../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function MisijaCiljevi() {
  const { t, i18n } = useTranslation();
  const isEN = i18n?.language?.toLowerCase().startsWith("en");

  const focusCards = useMemo(
    () => [
      {
        icon: "fa-graduation-cap",
        title: t("misijaciljevi.focus1.title"),
        text: t("misijaciljevi.focus1.text"),
      },
      {
        icon: "fa-flask",
        title: t("misijaciljevi.focus2.title"),
        text: t("misijaciljevi.focus2.text"),
      },
      {
        icon: "fa-globe-europe",
        title: t("misijaciljevi.focus3.title"),
        text: t("misijaciljevi.focus3.text"),
      },
      {
        icon: "fa-handshake",
        title: t("misijaciljevi.focus4.title"),
        text: t("misijaciljevi.focus4.text"),
      },
    ],
    [t],
  );

  const valueCards = useMemo(
    () => [
      {
        icon: "fa-award",
        title: t("misijaciljevi.values.v1.title"),
        text: t("misijaciljevi.values.v1.text"),
      },
      {
        icon: "fa-shield-alt",
        title: t("misijaciljevi.values.v2.title"),
        text: t("misijaciljevi.values.v2.text"),
      },
      {
        icon: "fa-balance-scale",
        title: t("misijaciljevi.values.v3.title"),
        text: t("misijaciljevi.values.v3.text"),
      },
      {
        icon: "fa-lightbulb",
        title: t("misijaciljevi.values.v4.title"),
        text: t("misijaciljevi.values.v4.text"),
      },
      {
        icon: "fa-globe",
        title: t("misijaciljevi.values.v5.title"),
        text: t("misijaciljevi.values.v5.text"),
      },
      {
        icon: "fa-briefcase",
        title: t("misijaciljevi.values.v6.title"),
        text: t("misijaciljevi.values.v6.text"),
      },
      {
        icon: "fa-users",
        title: t("misijaciljevi.values.v7.title"),
        text: t("misijaciljevi.values.v7.text"),
      },
      {
        icon: "fa-comments",
        title: t("misijaciljevi.values.v8.title"),
        text: t("misijaciljevi.values.v8.text"),
      },
      {
        icon: "fa-user-graduate",
        title: t("misijaciljevi.values.v9.title"),
        text: t("misijaciljevi.values.v9.text"),
      },
      {
        icon: "fa-leaf",
        title: t("misijaciljevi.values.v10.title"),
        text: t("misijaciljevi.values.v10.text"),
      },
    ],
    [t],
  );

  return (
    <>
      <Navbar />

      <Bredcom
        title={isEN ? "Home" : "Početna"}
        subtitle={
          isEN ? "Mission, Vision and Values" : "Misija, vizija i vrijednosti"
        }
      />

      <div className="container mt-4 pt-40 mvv-page">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container textjustify">
              {/* HERO / INTRO */}
              <section className="mvv-hero" aria-labelledby="mvv-hero-title">
                <div className="mvv-hero__eyebrow">
                  {t("misijaciljevi.eyebrow")}
                </div>

                <h1 id="mvv-hero-title" className="mvv-hero__title">
                  {t("misijaciljevi.heroTitle")}
                </h1>

                <p className="mvv-hero__lead">{t("misijaciljevi.lead")}</p>

                <div
                  className="mvv-hero__actions"
                  aria-label={t("misijaciljevi.actionsAria")}
                >
                  <Link
                    to="/strategija-razvoja-fpep-2026-2029"
                    className="btn mvv-btn"
                  >
                    {t("misijaciljevi.strategyCta")}
                    <i className="fas fa-arrow-right" aria-hidden="true" />
                  </Link>

                  <div className="mvv-hero__hint">
                    {t("misijaciljevi.strategyNote")}
                  </div>
                </div>

                <nav
                  className="mvv-jumps"
                  aria-label={t("misijaciljevi.jumpAria")}
                >
                  <a href="#mvv-focus" className="mvv-jump">
                    {t("misijaciljevi.jumpFocus")}
                  </a>
                  <a href="#mvv-mission" className="mvv-jump">
                    {t("misijaciljevi.jumpMission")}
                  </a>
                  <a href="#mvv-vision" className="mvv-jump">
                    {t("misijaciljevi.jumpVision")}
                  </a>
                  <a href="#mvv-values" className="mvv-jump">
                    {t("misijaciljevi.jumpValues")}
                  </a>
                </nav>
              </section>

              {/* FOCUS 2026–2029 */}
              <section
                className="mvv-section"
                id="mvv-focus"
                aria-labelledby="mvv-focus-title"
              >
                <div className="mvv-section__head">
                  <h2 id="mvv-focus-title" className="mvv-section__title">
                    {t("misijaciljevi.focusTitle")}
                  </h2>
                  <p className="mvv-section__lead">
                    {t("misijaciljevi.focusLead")}
                  </p>
                </div>

                <div className="row">
                  {focusCards.map((c, idx) => (
                    <div className="col-lg-6" key={idx}>
                      <article className="mvv-card mvv-card--focus">
                        <div className="mvv-card__icon" aria-hidden="true">
                          <i className={`fas ${c.icon}`} />
                        </div>
                        <div className="mvv-card__body">
                          <h3 className="mvv-card__title">{c.title}</h3>
                          <p className="mvv-card__text">{c.text}</p>
                        </div>
                      </article>
                    </div>
                  ))}
                </div>
              </section>

              {/* MISSION */}
              <section
                className="mvv-section"
                id="mvv-mission"
                aria-labelledby="mvv-mission-title"
              >
                <header className="mvv-statement__head">
                  <div className="mvv-statement__badge" aria-hidden="true">
                    <i className="fas fa-bullseye" />
                  </div>
                  <h2 id="mvv-mission-title" className="mvv-section__title">
                    {t("misijaciljevi.mission.title")}
                  </h2>
                </header>

                <div className="mvv-statement">
                  <p>{t("misijaciljevi.mission.p1")}</p>
                  <p>{t("misijaciljevi.mission.p2")}</p>
                  <p className="mb-0">{t("misijaciljevi.mission.p3")}</p>
                </div>
              </section>

              {/* VISION */}
              <section
                className="mvv-section"
                id="mvv-vision"
                aria-labelledby="mvv-vision-title"
              >
                <header className="mvv-statement__head">
                  <div className="mvv-statement__badge" aria-hidden="true">
                    <i className="fas fa-compass" />
                  </div>
                  <h2 id="mvv-vision-title" className="mvv-section__title">
                    {t("misijaciljevi.vision.title")}
                  </h2>
                </header>

                <div className="mvv-statement">
                  <p>{t("misijaciljevi.vision.p1")}</p>
                  <p>{t("misijaciljevi.vision.p2")}</p>
                  <p className="mb-0">{t("misijaciljevi.vision.p3")}</p>
                </div>
              </section>

              {/* VALUES */}
              <section
                className="mvv-section"
                id="mvv-values"
                aria-labelledby="mvv-values-title"
              >
                <div className="mvv-section__head">
                  <h2 id="mvv-values-title" className="mvv-section__title">
                    {t("misijaciljevi.valuesTitle")}
                  </h2>
                  <p className="mvv-section__lead">
                    {t("misijaciljevi.valuesLead")}
                  </p>
                </div>

                <div className="row">
                  {valueCards.map((v, idx) => (
                    <div className="col-lg-6" key={idx}>
                      <article className="mvv-card mvv-card--value">
                        <div
                          className="mvv-card__icon mvv-card__icon--value"
                          aria-hidden="true"
                        >
                          <i className={`fas ${v.icon}`} />
                        </div>
                        <div className="mvv-card__body">
                          <h3 className="mvv-card__title">{v.title}</h3>
                          <p className="mvv-card__text">{v.text}</p>
                        </div>
                      </article>
                    </div>
                  ))}
                </div>
              </section>
            </div>
          </div>

          {/* SIDEBAR: ostaje isto */}
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">{t("sidebar.follow")}</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Facebook"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Instagram"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>

              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">{t("sidebar.useful")}</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">{t("about.fpep")}</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">
                      {t("admission.Akreditacija")}
                    </Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">{t("upis.title")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">{t("admission.Skolarina")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">{t("saradnja.projekti")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">{t("navbar.Gallery")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">{t("navbar.News")}</Link>
                  </li>
                </ul>
              </section>

              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">{t("sidebar.study")}</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.osnovne")}</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      {t("osnovne.rfb")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      {t("osnovne.menadzment")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      {t("osnovne.pravo")}
                      <br />
                    </Link>
                  </li>

                  <li>
                    <span className="post-date">
                      <strong>{t("programs.master")}</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      {t("master.poslovnaEkonomija")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      {t("master.ekonomijaJavnogSektora")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      {t("master.pravo")}
                      <br />
                    </Link>
                  </li>

                  <li>
                    <span className="post-date">
                      <strong>{t("programs.specijalisticke")}</strong> <br />
                    </span>
                    <Link to="/menadzment-javnog-sektora-specijalisticke">
                      {t("specijalisticke.mjs")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment-profitnog-sektora-specijalisticke">
                      {t("specijalisticke.mps")}
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default MisijaCiljevi;
